import {Voicemail, VoicemailDetails} from "../../actions/payloads";
import * as actions from '../../actions';
import {ActionType, createReducer} from 'typesafe-actions';

export interface VoicemailsStateType {
    accountVoicemails?: AccountVoicemail[];
    voicemailDetails?: VoicemailDetails;
    isLoadingVoicemailDetails?: boolean;
    isUpdatingMessageFlag?: boolean;
    isDeletingVoicemail?: boolean;
}

export interface AccountVoicemail {
    voicemails?: Voicemail[];
    i_account?: number;
    isLoadingVoicemails?: boolean;
}

export const initialState: VoicemailsStateType = {
};

export type voicemailsActionsType = ActionType<typeof actions>;

const voicemailsReducer = createReducer<
        VoicemailsStateType,
        voicemailsActionsType
    >(initialState)
        .handleAction(actions.getVoicemailList.request, (state, action) => ({
            ...state,
            isLoadingVoicemails: true,
            voicemails: [
                ... (state.accountVoicemails ?? []).filter(e => e.i_account !== action.payload.i_account),
                {
                    i_account: action.payload.i_account,
                    voicemails: undefined,
                    isLoadingVoicemails: true,
                }
            ]
        }))
        .handleAction(actions.getVoicemailList.success, (state, action) => ({
            ...state,
            accountVoicemails: [
                ...(state.accountVoicemails ?? []).filter(e => e.i_account !== action.payload.i_account),
                {
                    ...action.payload,
                    isLoadingVoicemails: false,
                }
            ],
        }))
        .handleAction(actions.getVoicemailList.failure, (state) => ({
            ...state,
        }))
        .handleAction(actions.setMailboxMessagesFlag.request, (state) => ({
            ...state,
            isUpdatingMessageFlag: true,
        }))
        .handleAction(actions.setMailboxMessagesFlag.success, (state, action) => {
            // When i_account is undefined/0 (account user), use first entry
            const accVoiceMail = action.payload.i_account
                ? state.accountVoicemails?.find(e => e.i_account === action.payload.i_account)
                : state.accountVoicemails?.[0];
            if(!accVoiceMail) {
                return {
                    ...state,
                    isUpdatingMessageFlag: false,
                };
            }
            accVoiceMail.voicemails = (accVoiceMail?.voicemails ?? [])
                .map(e => {
                    let flags = e.flags ?? [];
                    if(action.payload.message_uids.includes(e.message_uid)) {
                        if(action.payload.action == "set_flag") {
                            //@ts-ignore
                            if(!flags.includes('\\' + action.payload.flag)) flags.push('\\' + action.payload.flag);
                            if(action.payload.flag == 'Seen') {
                                flags = flags.filter(c => c !== '\\Recent');
                            }
                        } else {
                            flags = flags.filter(c => c !== ('\\' + action.payload.flag));
                        }
                    }
                    return {
                        ...e,
                        flags: flags
                    }
                });
            const newVoiceMails = action.payload.i_account
                ? [
                    ...(state.accountVoicemails ?? []).filter(e => e.i_account !== action.payload.i_account),
                    accVoiceMail
                ]
                : [accVoiceMail];
            const updatedFlags = accVoiceMail.voicemails?.find(e => action.payload.message_uids.includes(e.message_uid))?.flags;
            const newVoicemailDetails = state.voicemailDetails && action.payload.message_uids.includes(state.voicemailDetails.message_uid)
                ? {
                    ...state.voicemailDetails,
                    flags: updatedFlags ?? state.voicemailDetails.flags
                }
                : state.voicemailDetails;
            return {
                ...state,
                accountVoicemails: newVoiceMails,
                isUpdatingMessageFlag: false,
                voicemailDetails: newVoicemailDetails
            };
        })
        .handleAction(actions.setMailboxMessagesFlag.failure, (state) => ({
            ...state,
            isUpdatingMessageFlag: false,
        }))
        .handleAction(actions.getVoicemailDetails.request, (state) => ({
            ...state,
            isLoadingVoicemailDetails: true,
        }))
        .handleAction(actions.getVoicemailDetails.success, (state, action) => ({
            ...state,
            isLoadingVoicemailDetails: false,
            voicemailDetails: action.payload
        }))
        .handleAction(actions.getVoicemailDetails.failure, (state) => ({
            ...state,
            isLoadingVoicemailDetails: false,
        }))
        .handleAction(actions.getVoicemailFile.request, (state) => ({
            ...state,
        }))
        .handleAction(actions.getVoicemailFile.success, (state) => ({
            ...state,
        }))
        .handleAction(actions.getVoicemailFile.failure, (state) => ({
            ...state,
        }))
        .handleAction(actions.deleteVoicemail.request, (state) => ({
            ...state,
            isDeletingVoicemail: true,
        }))
        .handleAction(actions.deleteVoicemail.success, (state) => ({
            ...state,
            isDeletingVoicemail: false
        }))
        .handleAction(actions.deleteVoicemail.failure, (state) => ({
            ...state,
            isDeletingVoicemail: false,
        }))
;

export default voicemailsReducer;